import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WorkflowService } from '../../../../../coverpath-common/angular/services/workflow/workflow.service';

@Injectable()
export class ApplicationFormGuard implements CanActivate {
  constructor(
    private router: Router,
    private workflowService: WorkflowService,
    private amorphicService: AmorphicService
  ) {}

  canActivate() {
    const isAnnuity =
      this.amorphicService.controller &&
      this.amorphicService.controller.customer &&
      this.amorphicService.controller.customer.application &&
      this.amorphicService.controller.customer.application.primaryPolicy &&
      this.amorphicService.controller.customer.application.primaryPolicy.isAnnuity();
    if (this.workflowService.isPreSubmit() && !isAnnuity) {
      return true;
    } else {
      this.router.navigate(['account-center']);
      return false;
    }
  }
}
